// ABOUTME: Attributes generic-path requests to their i18next configuration and active transition.
// ABOUTME: Sends a bounded, anonymous diagnostic without changing translation requests.
export type TranslationPathSource =
    | "boot_default"
    | "boot_stored"
    | "authenticated_ready"
    | "authenticated_zero_company"
    | "authenticated_company_failed"
    | "public_route"
    | "public_not_found";

const INTERNAL_MODULES = new Set(["APPBAR", "NAVIGATION", "CHANGELANGUAGE"]);
const reported = new Set<string>();

const routeKey = () => {
    const pathname = window.location.pathname;
    if (/^\/job\/view\//.test(pathname)) return "/job/view/*";
    if (/^\/applicant\/list\/?$/.test(pathname)) return "/applicant/list";
    if (/^\/job\/list\/?$/.test(pathname)) return "/job/list";
    if (/^\/login\/?$/.test(pathname)) return "/login";
    return "/other";
};

export const reportGenericInternalTranslation = (
    path: string,
    source: TranslationPathSource,
    transitionSource: TranslationPathSource,
    namespaces: string[]
) => {
    try {
        if (!/\/general\/translation\/0\/0$/.test(path)) return;
        if (navigator.onLine === false || reported.size >= 8) return;
        const namespace = namespaces.find((item) => INTERNAL_MODULES.has(item));
        if (!namespace) return;

        const routePath = routeKey();
        const key = `${source}:${transitionSource}:${routePath}`;
        if (reported.has(key)) return;
        reported.add(key);

        void fetch(
            `${import.meta.env.VITE_API_ADDRESS}/log/logfrontendperformance`,
            {
                method: "POST",
                headers: { "Content-Type": "text/plain" },
                body: JSON.stringify({
                    source: "admin",
                    eventType: "translation_generic_load",
                    routePath,
                    durationMs: 0,
                    translationSource: source,
                    translationTransitionSource: transitionSource,
                    translationNamespace: namespace
                }),
                keepalive: true
            }
        ).catch(() => {});
    } catch {
        // Diagnostics cannot interrupt translation loading.
    }
};
